<template>
    <div class="validation" v-if="turnaround && numberWords > 0">
        <p>
            We're sorry but your document has {{ numberWords }}
            {{ wordPage }} which is too many {{ wordPage }} for your selected
            turnaround speed. Please see our {{ wordPage }} limits below and
            choose a turnaround speed that is accepted.
        </p>
        <ul>
            <li>
                For document over {{ maxLimit }} {{ wordPage }}, please email us
                on
                <a href="mailto:contact@translationpal.com"
                    >contact@translationpal.com</a
                ><br />
                or call <a href="tel:855-500-2720">855-500-2720</a> for pricing.
            </li>
            <li v-for="turnaround in turnarounds" :key="turnaround.key">
                {{ turnaround.FriendlyName }} turnaround
                {{ wordLimit(turnaround) }} {{ wordPage }} limit
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        turnaround: [Object, Boolean],
        turnarounds: [Array, Boolean],
        numberWords: [Number, Boolean, String],
        SelectedData: Object,
        CheckoutData: Object,
    },
    methods: {
        wordLimit(turnaround) {
            let WordLimit = parseInt(turnaround.WordLimit);
            if (this.SelectedData.expertise == "Certified") {
                WordLimit = parseInt(turnaround.wordLimitCertified);
            } else if (
                this.CheckoutData.specialTurnarounds.includes(turnaround.ID) ||
                this.CheckoutData.inhouseTurnarounds.includes(turnaround.ID)
            ) {
                WordLimit = parseInt(turnaround.wordLimitInhouse);
            }
            return WordLimit;
        },
    },
    computed: {
        maxLimit() {
            const turnaround = this.CheckoutData.turnarounds[0];
            let WordLimit = parseInt(turnaround.WordLimit);
            if (this.SelectedData.expertise == "Certified") {
                WordLimit = parseInt(turnaround.wordLimitCertified);
            } else if (
                this.CheckoutData.specialTurnarounds.includes(turnaround.ID) ||
                this.CheckoutData.inhouseTurnarounds.includes(turnaround.ID)
            ) {
                WordLimit = parseInt(turnaround.wordLimitInhouse);
            }
            return WordLimit;
        },
        wordPage() {
            if (this.SelectedData.expertise == "Certified") {
                return "pages";
            }
            return "words";
        },
    },
};
</script>
